import { Injectable } from '@angular/core';

export let scripts = {
  stripe: 'https://js.stripe.com/v3/',
};

@Injectable({
  providedIn: 'root',
})
export class ExternalScriptService {
  constructor() {}

  loadStripe(): Promise<void> {
    return this.loadScript('stripe');
  }

  loadScript(key: string, url: string = null): Promise<void> {
    return new Promise((resolve, reject) => {
      if (url == null) url = scripts[key];
      if (url == null) reject();

      let id = `app-external-${key}`;

      if (window.document.getElementById(id)) resolve();

      const scriptElement = window.document.createElement('script');

      scriptElement.id = id;
      scriptElement.src = url;

      scriptElement.onload = () => {
        console.log('Loaded in service');
        resolve();
      };

      scriptElement.onerror = () => {
        console.log('Service error');
        reject();
      };

      window.document.body.appendChild(scriptElement);
    });
  }
}
